import React from 'react';
import './Footer.css';

const Footer = ({ onNavigate }) => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <button 
            onClick={() => onNavigate('privacy-policy')} 
            className="footer-link"
          >
            Privacy Policy
          </button>
          <button 
            onClick={() => onNavigate('terms-and-conditions')} 
            className="footer-link"
          >
            Terms & Conditions
          </button>
          <button 
            onClick={() => onNavigate('delete-account')} 
            className="footer-link"
          >
            Delete My Account
          </button>
        </div>
        <div className="footer-copyright">
          © 2025 Sunking. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;